module.exports = __webpack_public_path__ + "media/images/flags/64/Togo-42ed87fac5884fbd318ff8ba6d1cd3cd.png";